import type { ProvinceWardValue } from '@/components/forms/province-ward-picker'

import { ProvinceWardPicker } from '@/components/forms/province-ward-picker'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { m } from '@/lib/paraglide/messages'

/** The receiver block as shown on the booking form. Mirrors the order's
 *  customer/shipping fields; edits are written back to the order on booking. */
export interface CarrierReceiverValue {
    name: string
    phone: string
    address: string
    provinceCode?: string
    provinceName?: string
    wardCode?: string
    wardName?: string
}

interface Props {
    value: CarrierReceiverValue
    onChange: (next: CarrierReceiverValue) => void
    /** False when the order can no longer be edited (paid or out for delivery). */
    editable: boolean
}

export function CarrierReceiverFields({ value, onChange, editable }: Props) {
    const adminUnits: ProvinceWardValue = {
        provinceCode: value.provinceCode,
        provinceName: value.provinceName,
        wardCode: value.wardCode,
        wardName: value.wardName,
    }
    return (
        <fieldset className="space-y-3 rounded-md border p-3">
            <legend className="px-1 text-sm font-medium">
                {m.carrier_form_receiver_title()}
            </legend>
            <div className="space-y-1">
                <label
                    className="text-sm font-medium"
                    htmlFor="carrier-receiver-name"
                >
                    {m.customer_name_label()}
                </label>
                <Input
                    id="carrier-receiver-name"
                    value={value.name}
                    disabled={!editable}
                    onChange={(e) =>
                        onChange({ ...value, name: e.target.value })
                    }
                />
            </div>
            <div className="space-y-1">
                <label
                    className="text-sm font-medium"
                    htmlFor="carrier-receiver-phone"
                >
                    {m.customer_phone_label()}
                </label>
                <Input
                    id="carrier-receiver-phone"
                    type="tel"
                    value={value.phone}
                    disabled={!editable}
                    onChange={(e) =>
                        onChange({ ...value, phone: e.target.value })
                    }
                />
            </div>
            <div className="space-y-1">
                <label
                    className="text-sm font-medium"
                    htmlFor="carrier-receiver-address"
                >
                    {m.customer_shipping_address()}
                </label>
                <Textarea
                    id="carrier-receiver-address"
                    value={value.address}
                    disabled={!editable}
                    onChange={(e) =>
                        onChange({ ...value, address: e.target.value })
                    }
                />
            </div>
            <ProvinceWardPicker
                value={adminUnits}
                disabled={!editable}
                onChange={(next) => onChange({ ...value, ...next })}
            />
            <p className="text-muted-foreground text-xs">
                {editable
                    ? m.carrier_form_receiver_hint()
                    : m.carrier_form_receiver_locked()}
            </p>
        </fieldset>
    )
}
